<template>
    <div
        ref="stub"
        class="sbs-video-player-stub">
        <SbsVideoPlayerStubIcon class="sbs-video-player-stub__icon" />
        <span class="sbs-video-player-stub__text">
            Видео открыто<br>
            в отдельном окне
        </span>
    </div>
</template>

<script>
import videojs from 'video.js';
import SbsVideoPlayerStubIcon from './SbsVideoPlayerStubIcon.vue';
export default {
    name: 'SbsVideoPlayerStub',
    components: {
        SbsVideoPlayerStubIcon,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    computed: {
        player() {
            return this.videoPlayerComponent.player;
        },
    },
    mounted() {
        const Component = videojs.getComponent('Component');
        const pictureInPictureComponent = new Component(this.player, {
            el: this.$refs.stub,
        });

        this.player.addChild(pictureInPictureComponent);
    },
};
</script>

<style lang="scss">
.sbs-video-player-stub {
    position: absolute;
    z-index: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: $gray-deep;
    inset: 0;

    &__icon {
        width: 150px;
        height: 150px;
        margin: 0 auto 14px;
    }

    &__text {
        color: $white;

        @include typo-subprimary-medium;
    }
}
</style>
